import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  groupsList: []
};
const groupsReducer = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getGroupsList(state, action) {
      return {
        ...state,
        groupsList: action.payload?.data
      };
    },
    getGroupById(state, action) {
      return {
        ...state,
        groupInfo: action.payload?.data
      };
    }
  }
});

export default groupsReducer.reducer;

export const GroupsActions = groupsReducer.actions;

export const createGroup = (role) => async () => {
  try {
    const res = await api.post(`api/VehicleGroup`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editGroup = (data, id) => async () => {
  try {
    const res = await api.put(`api/VehicleGroup/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getGroupsAction = (data) => async (dispatch) => {
  dispatch(GroupsActions.setLoading(true));
  try {
    const res = await api.get(`api/VehicleGroup`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(GroupsActions.getGroupsList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(GroupsActions.setLoading(false));
  }
};
export const getGroupById = (id) => async (dispatch) => {
  dispatch(GroupsActions.setLoading(true));
  try {
    const res = await api.get(`api/VehicleGroup/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(GroupsActions.getGroupById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(GroupsActions.setLoading(false));
  }
};
export const clearGroupById = () => async (dispatch) => {
  dispatch(GroupsActions.getGroupById(''));
};
export const removeGroupAction = (id, setRemoveDialog) => async (dispatch) => {
  try {
    const res = await api.delete(`api/VehicleGroup/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(getGroupsAction());
      setRemoveDialog('');
      toast.success('Removed successfully!!!');
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
  }
};
